<template>
	<div>
		<!-- 조건 트리거: 점포검색과 동일하게 각 조건별 +버튼으로 모달을 연다 (지역선택 / 필터링 / 태그) -->
		<v-row class="ma-0 pa-0 pb-2 pl-1" align="center">
			{{ t('theConditions') }}:
			<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-3"
				id="back_clean_btn" elevation="0" @click="regionDialogOpen">
				<v-row class="ma-0 pa-0" align="center" style="color:white;">
					<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 mr-2"
						src="@/assets/images/plus_white.png"></v-img>
					{{ tsc('region') }}
				</v-row>
			</v-btn>
			<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-3"
				id="back_clean_btn" elevation="0" @click="filterDialogOpen">
				<v-row class="ma-0 pa-0" align="center" style="color:white;">
					<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 mr-2"
						src="@/assets/images/plus_white.png"></v-img>
					{{ t('filtering') }}
				</v-row>
			</v-btn>
			<v-btn width="auto" height="auto" class="ma-0 pa-2 ml-3"
				id="back_clean_btn" elevation="0" @click="tagDialogOpen">
				<v-row class="ma-0 pa-0" align="center" style="color:white;">
					<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0 mr-2"
						src="@/assets/images/plus_white.png"></v-img>
					{{ t('tag') }}
				</v-row>
			</v-btn>
		</v-row>
		<v-col class="ma-0 pa-0" cols="12" id="noneBorderBox">
			<template v-if="areaLoading == false">
				<template v-if="storeList.length > 0">
					<v-treeview selected-color="blue" selectable dark dense return-object
						v-model="selectedCameras" :items="storeList" item-key="id">
						<template v-slot:label="{ item }">
							<v-col class="ma-0 pa-0" cols="auto">{{ item.name }}</v-col>
						</template>
					</v-treeview>
				</template>
				<template v-else>
					<v-col class="ma-0 pa-10" cols="12">{{ t('noData') }}</v-col>
				</template>
			</template>
			<template v-else>
				<v-skeleton-loader :boilerplate="false" elevation="0" dark
					type="list-item-three-line, list-item-two-line, list-item-three-line"></v-skeleton-loader>
			</template>
		</v-col>

		<!-- 지역선택 모달 (점포검색과 동일). 자체 점포목록/선택지역을 주입한다. -->
		<StoreSearchDialog :dialogVisible="regionDialogVisible" :storeData="allStores" :preSelectedAreas="selectedAreas"
			@visible="regionDialogVisibleFunc" @editArea="editAreaFunc" />
		<!-- 조건 필터링 모달 (점포검색과 동일: 브랜드박스 없이 모션/사운드 조건만) -->
		<FilterDialog :dialogVisible="filterDialogVisible" :brandBoxVisible="false" :filterData="filteredData"
			@visible="filterDialogVisibleFunc" @filterParams="filterParamsFunc" />
		<!-- 태그선택 모달 (점포검색과 동일). 자체 tagNames 를 주입한다. -->
		<TagDialog :dialogVisible="tagDialogVisible" :preselectTagNames="tagNames"
			@tagVisible="tagDialogVisibleFunc" @tagNames="tagNamesFunc" />
	</div>
</template>

<script>
import mixin from '@/mixin';
import FilterDialog from '@/components/dialogs/FilteringDialog.vue';
import StoreSearchDialog from '@/components/dialogs/StoreSearchDialog.vue';
import TagDialog from '@/components/dialogs/TagDialog.vue';
import {
	getBrandListCached,
	getAllStoresCached,
	filterStoresBySelectedBrands,
} from '@/api/storeSearchCache';
export default {
	props: {
		// 선택된 카메라 목록 (v-model)
		value: { type: Array, default: () => [] },
	},
	components: {
		FilterDialog, StoreSearchDialog, TagDialog
	},
	mixins: [mixin.common],
	data: () => ({
		storeList: [],        // 도도부현 → 점포 → 카메라 트리
		selectedCameras: [],  // 선택된 카메라(말단 노드) 목록
		areaLoading: false,
		allStores: [],        // 지역선택 모달에 넘길 전체 점포 목록 (브랜드 전체 기준)
		filterDialogVisible: false,
		regionDialogVisible: false,
		tagDialogVisible: false,
		filteredData: {},     // 필터 다이얼로그에 전달할 현재 조건
		selectedAreas: [],    // 선택된 지역(areaName) 목록
		tagNames: '',         // 선택된 태그명(콤마 구분)
		// 条件絞り込み 조건 (모션/사운드 감지 기간). 트리 카메라 조회에 함께 반영된다.
		filterConditions: {
			motionBeginDate: '',
			motionEndingDate: '',
			soundBeginDate: '',
			soundEndingDate: '',
		},
	}),
	watch: {
		selectedCameras(val) {
			this.$emit('input', val);
		},
		// 부모가 선택값을 초기화(예: 다이얼로그 재오픈)하면 반영
		value(val) {
			if (val !== this.selectedCameras) this.selectedCameras = val || [];
		},
	},
	created() {
		this.selectedCameras = this.value || [];
	},
	mounted() {
		this.buildCameraTree();
	},
	methods: {
		// 브랜드 전체 선택 상태로 점포를 불러온 뒤, 점포별 전체 카메라(getStoreCameraList)를
		// 조회하여 도도부현 → 점포 → 카메라 트리를 구성한다. 条件絞り込み 조건도 함께 반영한다.
		async buildCameraTree() {
			this.areaLoading = true;
			this.storeList = [];
			try {
				const brands = await getBrandListCached();
				const allStores = filterStoresBySelectedBrands(await getAllStoresCached(), brands);
				this.allStores = allStores; // 지역선택 모달용(전체 지역 노출)
				// 지역선택 조건이 있으면 해당 지역(areaName)의 점포만 트리에 포함
				const stores = (this.selectedAreas && this.selectedAreas.length)
					? allStores.filter((s) => this.selectedAreas.includes(s.areaName))
					: allStores;
				const f = this.filterConditions;
				// 점포별 전체 카메라를 병렬 조회 (store당 4개 제한 없음). 태그 조건도 함께 반영.
				const results = await Promise.all(stores.map(async (store) => {
					try {
						const res = await this.networkController.getStoreCameraList(
							{}, store.unisCustomerCd,
							f.motionBeginDate, f.motionEndingDate, f.soundBeginDate, f.soundEndingDate, this.tagNames);
						return { store, cameras: (res && res.data) || [] };
					} catch (e) {
						return { store, cameras: [] };
					}
				}));
				const prefMap = new Map();
				results.forEach(({ store, cameras }) => {
					const cameraLeaves = cameras.map((cam) => ({
						id: `cam_${cam.contractCd}_${cam.portNo}`,
						name: cam.cameraName,
						cameraName: cam.cameraName,
						contractCd: cam.contractCd,
						portNo: cam.portNo,
						unisCustomerCd: cam.unisCustomerCd || store.unisCustomerCd,
						thingType: cam.thingType,
					}));
					if (cameraLeaves.length === 0) return;
					const storeNode = {
						id: `store_${store.unisCustomerCd}`,
						name: store.customerName,
						children: cameraLeaves,
					};
					const pref = store.unisCustomerPref || '-';
					if (!prefMap.has(pref)) {
						prefMap.set(pref, { id: `pref_${pref}`, name: pref, children: [] });
					}
					prefMap.get(pref).children.push(storeNode);
				});
				this.storeList = Array.from(prefMap.values());
			} catch (e) {
				console.error('buildCameraTree failed', e);
			} finally {
				this.areaLoading = false;
			}
		},
		filterDialogOpen() {
			this.filteredData = this.filterConditions;
			this.filterDialogVisible = true;
		},
		filterDialogVisibleFunc(visible) {
			this.filterDialogVisible = visible;
		},
		filterParamsFunc(params) {
			this.filterConditions = params;
			this.buildCameraTree();
		},
		regionDialogOpen() {
			this.regionDialogVisible = true;
		},
		regionDialogVisibleFunc(visible) {
			this.regionDialogVisible = visible;
		},
		editAreaFunc(areas) {
			this.selectedAreas = areas || [];
			this.buildCameraTree();
		},
		tagDialogOpen() {
			this.tagDialogVisible = true;
		},
		tagDialogVisibleFunc(visible) {
			this.tagDialogVisible = visible;
		},
		tagNamesFunc(tagNames) {
			this.tagNames = tagNames || '';
			this.buildCameraTree();
		},
	}
}
</script>

<style lang="scss" scoped>
#back_clean_btn {
	background-color: transparent !important;
	min-width: 1rem !important;
	color: white;
}
#noneBorderBox {
	min-height: 350px;
	max-height: 350px;
	overflow: auto;
	text-align: left;
	color: white;
	&::-webkit-scrollbar {
		width: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: white;
	}
	&::-webkit-scrollbar-track {
		background-color: #4A4A4A;
	}
}
::v-deep {
	.v-treeview--dense .v-treeview-node__root {
		border-bottom: 1px solid #4A4A4A;
	}
	.v-treeview-node .v-treeview-node--leaf {
		border-bottom: 1px solid #4A4A4A;
	}
	.v-treeview-node__checkbox {
		background-color: white;
		border-radius: 5px;
		width: 18px;
		height: 18px;
		margin-left: 8px;
		margin-right: 5px;
	}
	.theme--dark.v-skeleton-loader .v-skeleton-loader__list-item-three-line {
		background: #171921 !important;
	}
	.theme--dark.v-skeleton-loader .v-skeleton-loader__list-item-two-line {
		background: #171921 !important;
	}
}
</style>
